

export const uiChatReducerActionTypes = {
  API_RESPONSE_SUCCESS: 'API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: 'API_RESPONSE_ERROR',
  GET_SYSTEM_RESPONSE: 'GET_SYSTEM_RESPONSE',
  SET_CONVERSATION_COMPONENT: 'SET_CONVERSATION_COMPONENT',
  SEND_APPROVED_ENTRY: 'SEND_APPROVED_ENTRY',
  SEND_IDENTITY_DOCUMENT: 'SEND_IDENTITY_DOCUMENT',
  RESET_IDENTITY_DOCUMENT: 'RESET_IDENTITY_DOCUMENT',
  DELETE_IDENTITY_DOCUMENT: 'DELETE_IDENTITY_DOCUMENT',
  
  LOAD_INITIAL_STATE_FROM_FILE: "LOAD_INITIAL_STATE_FROM_FILE",
  SAVE_STATE_TO_FILE: "SAVE_STATE_TO_FILE",
  SEND_MANUALLY_UPDATED_ENTRY : 'SEND_MANUALLY_UPDATED_ENTRY',
  DETECTED_LANGUAGE : 'DETECTED_LANGUAGE',
  SET_UICOMPONENT : 'SET_UICOMPONENT',
};


// Represents the UI component to render, coming from backend
export interface UiComponentDescriptor {
  type: string; // e.g. 'bookingEntryCard', 'checkoutCard', 'infoMessage'
  props: Record<string, any>; // props to pass to the component
}

export interface intent{
    customer_request: string | null;
    category: string | null;
    intent: string | null;
    intent_type: string | null;
    system_message?: string | null;
}



// A single turn in the conversation (either user or system)
export interface ConversationMessage {
  sender: 'user' | 'system';
  type: 'text' | 'audio' | 'ui-card' | 'info';
  text?: string;
  audioUrl?: string;
  uiComponent?: UiComponentDescriptor;
  data?: Record<string, any>;
  timestamp: number;
}

interface Hotel {
  hotel_id: number;
  owner_user_id: number | null;
  hotel_name: string;
  legal_name?: string;
  short_code?: string;
  phone?: string;
  email?: string;
  website?: string;
  address_line1?: string;
  address_line2?: string;
  city?: string;
  state?: string;
  country?: string;
  postal_code?: string;
  latitude?: number;
  longitude?: number;
  timezone: string;
  currency_code: string;
  check_in_time: string;
  check_out_time: string;
  gstin?: string;
  payment_method?: string;
  logo_path?: string;
  authorized_signatory_path?: string;
  is_active: boolean;

}

export type AudioStatus = 'clear' | 'audio_not_clear';




// uiChatReducerState
export interface uiChatReducerState {
  userUtterance: string | null;
  intent: intent | null;
  uiComponent: UiComponentDescriptor | null;
  agentLogId: number | null;
  missingFields: string[];
  history: ConversationMessage[]; // Timeline of user/system messages 
  guests: any[];
  approvalSuccess: boolean;
  loading: boolean;
  error: string | null;
  errorIdentityUpload: string | null;
  loadingIdentityDetails: boolean;
  update_message: string;
  update_success: boolean;
  detected_language: string | null;
  audio_status: AudioStatus;
  previous_screen_load_timestamp: number | null;
  previous_agent_log_id: number | null;
   /** When did the GET_SYSTEM_RESPONSE request start? (epoch ms) */
  systemResponseRequestStartTime: number | null;

  /** Time taken for last GET_SYSTEM_RESPONSE (in seconds, for UI) */
  lastSystemResponseTimeSeconds: number | null;
  // hotel: Hotel | null;
}





// conversationTypes.ts





